(function () {
  'use strict'

  /**
   * @ngdoc module
   * @name FormlyHtmlReadOnlyInput
   * @module thismoment.common.formly.inputs.html-read-only
   *
   * @description
   * A form item that renders raw text (with optional HTML).
   * This does not maintain anything in the form model.
   */

  var MODULE_NAME = 'thismoment.common.formly.inputs.html-read-only'
  var templateUrl = require('./tpl/html-read-only.html')

  require('dynamic-bind-html') // ಠ_ಠ

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml',
      require('angular-formly')
    ])
    .run(requiredConfig)

  requiredConfig.$inject = ['formlyConfig']
  function requiredConfig (formlyConfig) {
    formlyConfig.setType([
      {
        name: 'html-read-only',
        templateUrl: templateUrl,
        overwriteOk: true
      }
    ])
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/html-read-only.js